/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./modal.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives/compiled';
var modalBodyStyles = null;
var modalHeadingStyles = null;
var modalImageStyles = null;
var modalActionContainerStyles = null;
var modalActionContainerReversedStyles = null;
var modalActionItemStyles = {
  root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};

/**
 * __Modal body__
 *
 * @internal
 */
export var ModalBody = function ModalBody(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"])
  }, children);
};

/**
 * __Modal heading__
 *
 * @internal
 */
export var ModalHeading = function ModalHeading(_ref2) {
  var children = _ref2.children,
    id = _ref2.id;
  return /*#__PURE__*/React.createElement("h1", {
    id: id,
    className: ax(["_11c8lodh _syaz1kw7 _6rthu2gc"])
  }, children);
};

/**
 * __Modal image__
 *
 * @internal
 */
export var ModalImage = function ModalImage(_ref3) {
  var alt = _ref3.alt,
    src = _ref3.src;
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    src: src,
    className: ax(["_1bsb1osq _4t3i1wug _5fbc1sit _1s1g1sit _j722idpf"])
  });
};

/**
 * __Modal action container__
 *
 * @internal
 */
export var ModalActionContainer = function ModalActionContainer(_ref4) {
  var children = _ref4.children,
    shouldReverseButtonOrder = _ref4.shouldReverseButtonOrder;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw", shouldReverseButtonOrder && "_2lx21sbv"])
  }, children);
};

/**
 * __Modal action item__
 *
 * @internal
 */
export var ModalActionItem = function ModalActionItem(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: modalActionItemStyles.root
  }, children);
};